import { atom } from "jotai";

// Átomo que almacena la lista de tareas
export const forgotPasswordState = atom({
  key: "forgotPasswordState", // Debe ser único
  default: {
    email: "",
    key: "",
    password: "",
  }, // Estado inicial: false
});
